import React, { Component } from 'react'
import '../styles/CartItemVoucher.css'
import MagnifierIcon from '../images/Cart/magnifier.png'
import MailBlueIcon from '../images/Cart/mail2.png'
import { injectIntl, defineMessages } from "react-intl"

const formatDateWithZero = (date) => {
  const formattedDate = date.split("-")
  let y, M, d

  y = formattedDate[0]
  M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
  d = formattedDate[2].length < 2 ? `0${formattedDate[2]}` : formattedDate[2]

  return `${d}/${M}/${y}`
}


class CartItemVoucher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      price: 0
    }
  }

  formatDate = (date, slot) => {
    const slotHour = slot.split(":")[0]

    if (this.props.lang === "fr") {
      return `${formatDateWithZero(date)}, à ${slotHour}h`
    } else {
      return `${formatDateWithZero(date)}, ${slotHour}h`
    }
  }

  getPrice = () => {
    let price = 0
    if (this.props.voucher.paper_card) {
      price = this.props.voucher.price - 2
    } else {
      price = this.props.voucher.price
    }

    this.setState({ price: price })
  }

  componentDidMount() {
    this.getPrice()
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const voucher = this.props.voucher
    let r;

    if (this.props.readOnly) {
      r = (
          <div className="cart-item-readonly-element">
            <p>{formatMessage(messages.giftCard)}</p>
            <p>{Math.floor(this.state.price)},{(Math.round((this.state.price % 1) * 100) / 100).toFixed(2).split(".")[1]} €</p>
            <p>{voucher.paper_card ? formatMessage(messages.sendByPaperCard) : formatMessage(messages.sendByEmail)} {voucher.paper_card ? formatMessage(messages.shippingRates) : formatMessage(messages.shippingFree)}</p>
          </div>
        )
    } else {
      r =  (
        <div className="cart-summary-gift-card">
          <div className="cart-summary-section cart-item-header">
            <p>{formatMessage(messages.giftCard)}  {this.props.single ? "" : `#${this.props.id + 1}`}</p>
            <span className="cart-item-close" onClick={() => this.props.handleDelete(voucher)}></span>
          </div>
          <div className="cart-summary-section" style={{ justifyContent: "space-between" }}>
            <div className="cart-summary-section-label">
              <div className="cart-summary-section--icon" style={{ backgroundImage: `url(${MagnifierIcon})` }} />
              <p>{`${voucher.games} ${formatMessage(messages.game)}${voucher.games > 1 ? "s" : ""} x ${voucher.players} ${formatMessage(messages.player)}${voucher.players > 1 ? "s" : ""}`}</p>
            </div>
            <h3>{Math.floor(this.state.price)},{(Math.round((this.state.price % 1) * 100) / 100).toFixed(2).split(".")[1]} €</h3>
          </div>
          <div className="cart-summary-section cart-summary-total-price" style={{ justifyContent: "space-between", marginBottom: "7px" }}>
            <div className="cart-summary-section-label">
              <div className="cart-summary-section--icon" style={{ backgroundImage: `url(${MailBlueIcon})` }} />
              <p>{voucher.paper_card ? formatMessage(messages.sendByPaperCard) : formatMessage(messages.sendByEmail)}</p>
            </div>
            <h3 style={{ fontSize: "12px" }}>{voucher.paper_card ? formatMessage(messages.shippingRates) : formatMessage(messages.shippingFree)}</h3>
          </div>
        </div>
      )
    }

    return r;
  }
}

const messages = defineMessages({
    giftCard: {
    id: 'cart.giftCard',
    defaultMessage: "Carte cadeaux"
  },
    game: {
    id: 'cart.game',
    defaultMessage: "partie"
  },
    player: {
    id: 'cart.player',
    defaultMessage: "joueur"
  },
    sendByPaperCard: {
    id: 'cart.sendByPaperCard',
    defaultMessage: "Envoi par carte cadeaux"
  },
    sendByEmail: {
    id: 'cart.sendByEmail',
    defaultMessage: "Envoi par email"
  },
    shippingRates: {
    id: 'cart.shippingRates',
    defaultMessage: "2 €"
  },
    shippingFree: {
    id: 'cart.shippingFree',
    defaultMessage: "GRATUIT"
  },
})

export default injectIntl(CartItemVoucher)



// WEBPACK FOOTER //
// ./src/components/CartItemVoucher.js